import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ItemsXlsExportService } from "src/app/_services/items-xls-export.service";
import { ItemWithRelations } from "src/app/api/models";

@Component({
  selector: "art-items-export-button",
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTooltipModule],
  template: `
    <button
      class="hover:text-green-500"
      (click)="onExportXls()"
      color="info"
      mat-icon-button
      type="button"
      matTooltip="Stáhnout seznam děl"
    >
      <mat-icon svgIcon="mat:backup_table"></mat-icon>
    </button>
  `,
})
export class ItemsExportButtonComponent {
  @Input() items: ItemWithRelations[];
  @Input() title: string;

  constructor(private xlsExport: ItemsXlsExportService) {}

  onExportXls() {
    this.xlsExport.exportItems(this.items, this.title).catch(console.error);
  }
}
